import React from "react";

export function DashbboardHelp10() {
    return (
        <div style={{
            fontFamily: 'PPMoriRegular',
            textAlign: 'justify',
            marginRight: 40,
            fontSize: '1.2em'
        }}>
            <p>The Green Urban Growth scenario aligns with Indonesia's policy goals for sustainable urban development
                while preserving critical ecosystems such as mangroves and rainforests, which are vital for biodiversity
                and function as significant carbon sinks. It is aimed at achieving urban densification and promotes
                sustainable living and mobility, alongside significant ecosystem restoration efforts. </p>
            <p>This is achieved by implementing the following strategies.
                <ul>
                    <li><b>Urban Development:</b> The strategy includes increasing the floorspace for residential and
                        non-residential use to support population growth and enhance the availability of services. This
                        approach emphasizes the efficient use of space and resources to create sustainable urban areas
                        that can accommodate future growth without compromising environmental values.
                    </li>
                    <li><b>Transportation:</b> Efforts are being made to encourage community-oriented living by
                        enhancing infrastructure for bicycles and walking. This reduces reliance on cars, thereby
                        decreasing carbon emissions and fostering healthier, more active lifestyles. The promotion of
                        slow mobility options is a direct response to the need for sustainable urban transport solutions
                        that contribute to reduced environmental impact.
                    </li>
                    <li><b>Vegetation:</b> The expansion of mangrove forests and the preservation of existing
                        rainforests are key components of the strategy. Converting low-value land covers into high-value
                        ecosystems enhances biodiversity, increases carbon sequestration capabilities, and protects the
                        natural heritage of the region. This not only contributes to the global effort against climate
                        change but also strengthens the ecological resilience of the region.
                    </li>
                </ul></p>
            <p>Through these targeted actions, the Green Urban Growth scenario aims to illustrate how integrated
                urban planning and environmental conservation efforts can lead to sustainable development outcomes. This
                approach is grounded in scientific principles and seeks to balance human needs with environmental
                preservation, showcasing a model for sustainable urban growth that is replicable in other regions facing
                similar challenges.</p>
        </div>
    )
}